


































import {Vue, Component, Watch} from 'vue-property-decorator'
import { mixins } from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from "@/services/data-proxy.service";
import {formatDate} from "@/utils/formatters";

@Component({})
export default class UvozTahografa extends mixins(ComponentBaseMixin) {
    uvezeneDatoteke = [];
    file = null;
    columns = [];
    tableOptions = {
        pagination: true
    };

    isBusy = false;

    async created() {
        this.uvezeneDatoteke = await this.loadData(() => dataProxy.vratiUvezeneDatoteke())();
        this.columns = [
            {field: 'datum', title: this.$i18n.t('datum unosa'), formatter: formatDate, sortable: true},
            {field: 'naziv', title: this.$i18n.t('naziv datoteke')}
        ]
    }

    async sacuvajFajl() {
        if (this.isBusy) return;
        if (this.file) {
            try {
                this.isBusy = true;
                await this.saveData(() => dataProxy.uveziTahografDatoteku({fileName: this.file.name, data: this.file}))();
                this.uvezeneDatoteke = await this.loadData(() => dataProxy.vratiUvezeneDatoteke())();
            } finally {
                this.isBusy = false;
            }
        }
    }
}
